import React, { Component } from 'react';
import { AppContext } from '../context';
import ObjectSkeleton from '../skeleton/object.skeleton';
import Object from './object.component';
import { Grid, AutoSizer } from 'react-virtualized';
import Text from './text.component';
import '../styles/object-list.css';

class ObjectsList extends Component {
  static contextType = AppContext;
  context!: React.ContextType<typeof AppContext>;
  grid: any;

  constructor (props: any) {
    super(props);
    this.grid = React.createRef();
  }

  render ()  {
    const { state, dispatch } = this.context;
    const isLoading = (state.status === 'loading');
    const results = (state.results && state.results.nb > 0 ? state.results.results : false);
    const nbResults = (results !== false ? results.filter((result) => {
      return (! result.hidden);
    }).length : 0);

    const getColumnsByWidth = (width: number) => {
      return (width > 1200 ? 3 : (width > 680 ? 2 : 1));
    }

    return <div className='objects-list-container'>
      {isLoading ?
        <>
          <div className='heading'>
            <Text text={'Loading...'} />
          </div>
          <div className='list loading'>
            {[...Array(6)].map((value: any, index: number) =>
              <div className='object-container skeleton' key={index}>
                <ObjectSkeleton/>
              </div>
            )}
          </div>
        </>
      :
        <>
          <div className='heading'>
            <span className='number'>{nbResults}</span>
            &nbsp;
            <span className='text'>
              {nbResults > 1 ?
                <Text text={'properties found'} />
                :
                <Text text={'property found'} />
              }
            </span>
          </div>
          <div id='list-scroll-container' className='list'>
          {results ?
              <>
                <AutoSizer
                  onResize={() => {
                    this.grid.current?.recomputeGridSize();
                  }}
                  >
                  {({height, width}) => (
                    <Grid
                      columnCount={getColumnsByWidth(width)}
                      rowCount={Math.ceil(nbResults / getColumnsByWidth(width))}
                      noContentRenderer={() => {
                        return <div className='empty'>
                          <Text text={'Nothing found'}/>
                        </div>
                      }}
                      cellRenderer={({columnIndex, key, rowIndex, style}) => {
                        if (! results) {
                          return null;
                        }
                        const visibleObjects = results.filter((result) => {
                          return (! result.hidden);
                        });
                        const index = (rowIndex * getColumnsByWidth(width)) + columnIndex;
                        const object = ( visibleObjects[index] ? visibleObjects[index] : false );
                        if (! object) {
                          return null;
                        }
                        return (
                          <div className='object-container' style={style} key={key}
                            onMouseLeave={() => {
                              dispatch({
                                type: 'setHighlight',
                                payload: {
                                  highlight: false
                                }
                              });
                            }} onMouseEnter={() => {
                              dispatch({
                                type: 'setHighlight',
                                payload: {
                                  highlight: object.nid
                                }
                              });
                            }}>
                            <Object object={object}/>
                          </div>
                        );
                      }}
                      height={height}
                      rowHeight={505}
                      columnWidth={width / getColumnsByWidth(width)}
                      width={width}
                      ref={this.grid}
                    />
                  )}
                </AutoSizer>
              </>
            :
              <div className='empty'></div>
            }
          </div>
        </>
      }
    </div>
  };
}
export default ObjectsList;
